import { render, staticRenderFns } from "./AddRecruiters.vue?vue&type=template&id=bb8a9104&scoped=true"
import script from "./AddRecruiters.vue?vue&type=script&lang=js"
export * from "./AddRecruiters.vue?vue&type=script&lang=js"
import style0 from "./AddRecruiters.vue?vue&type=style&index=0&id=bb8a9104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8a9104",
  null
  
)

export default component.exports